import React, { useState } from "react";

const FAQSection = ({ faq }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleAnswer = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8 max-w-2xl mx-auto bg-white">
      <h2 className="text-xl sm:text-2xl font-semibold text-purple-700 mb-5">
        Frequently Asked Questions
      </h2>

      {faq.map((item, index) => (
        <div
          key={index}
          className="border-b border-gray-200 pb-3 mb-4 last:mb-0 last:border-none"
        >
          <button
            onClick={() => toggleAnswer(index)}
            className="w-full text-left flex justify-between items-center focus:outline-none"
          >
            <h3 className="text-sm sm:text-base font-medium text-purple-700">
              {item.question}
            </h3>
            <span className="text-lg font-bold text-purple-700 select-none">
              {expandedIndex === index ? "−" : "+"}
            </span>
          </button>
          {expandedIndex === index && (
            <p className="text-xs sm:text-sm text-gray-700 mt-2 leading-normal">
              {item.answer}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQSection;
